import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_form = _resolveComponent("login-form")!
  const _component_base_shadow_card = _resolveComponent("base-shadow-card")!
  const _component_layouts_guest = _resolveComponent("layouts-guest")!

  return (_openBlock(), _createBlock(_component_layouts_guest, null, {
    default: _withCtx(() => [
      _createVNode(_component_base_shadow_card, {
        title: _ctx.t('word.login')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_login_form)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}